// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — StatCard
// KPI display card with trend indicator and optional drill-down
// ══════════════════════════════════════════════════════════════════════════════

import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { useTheme } from '@contexts/ThemeContext';
import { useLang } from '@contexts/LangContext';
import { Card } from './Primitives';

export function StatCard({
  icon,
  label,
  value,
  subtext,
  trend,
  trendDirection, // 'up' | 'down'
  onClick,
  accentColor
}) {
  const { theme } = useTheme();
  const { t } = useLang();

  const accent = accentColor || theme.primary;
  const accentBg = accentColor ? `${accentColor}1A` : theme.primaryDim;

  return (
    <Card
      onClick={onClick}
      style={{ padding: '20px 22px' }}
      hoverable={!!onClick}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 14 }}>
        <div style={{
          background: accentBg,
          borderRadius: 10,
          padding: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {icon}
        </div>
        {trend !== undefined && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            color: trendDirection === 'up' ? theme.success : theme.danger,
            fontSize: 12,
            fontWeight: 600
          }}>
            {trendDirection === 'up' ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
            {trend}
          </div>
        )}
      </div>

      <div style={{
        fontSize: 26,
        fontWeight: 700,
        color: theme.text,
        letterSpacing: -0.5,
        lineHeight: 1.2
      }}>
        {value}
      </div>
      <div style={{ fontSize: 13, color: theme.textSecondary, marginTop: 4 }}>
        {label}
      </div>
      {subtext && (
        <div style={{ fontSize: 11, color: theme.textTertiary, marginTop: 4 }}>
          {subtext}
        </div>
      )}
      {onClick && (
        <div style={{ fontSize: 11, color: theme.primary, marginTop: 10, fontWeight: 600 }}>
          {t.viewDetails} →
        </div>
      )}
    </Card>
  );
}
